import { ReactNode } from 'react';

import { TranslatableText } from '@dreryk/react-common';
import { appendTestableElementAttributes, Heading, StyledFlex, TestableComponentProps } from '@dreryk/react-components';

type FormSectionProps = TestableComponentProps & {
   readonly children: ReactNode;
   readonly heading: TranslatableText;
};

export const FormSection = (props: FormSectionProps): JSX.Element => {
   return (
      <section {...appendTestableElementAttributes(props.testId)}>
         <Heading testId={props.testId} type={'h2'} margin={'12px'} content={props.heading} />
         <StyledFlex direction={'column'} gap={'12px'}>
            {props.children}
         </StyledFlex>
      </section>
   );
};
